import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class PartnerService {

  static getAllPartners() {
    return HttpUtil.get( API_ROUTES.PARTNER.GET_ALL_PARTNERS);
  }

  static saveUIConfig(partnerId, config) {
    return HttpUtil.post(API_ROUTES.PARTNER.SAVE_UI_CONFIG.replace('<partnerId>', partnerId), config);
  }

  static getUIConfig() {
    return HttpUtil.get( API_ROUTES.PARTNER.GET_UI_CONFIG);
  }

  static getPartnerSpecificUIConfig(partnerId) {
    return HttpUtil.get( API_ROUTES.PARTNER.GET_PARTNER_SPECIFIC_UI_CONFIG.replace('<partnerId>', partnerId));
  }
}
